import { call, all, spawn } from 'redux-saga/effects';

// Types
import { SagaIterator } from 'redux-saga';

import spraySubmissionsSagas from 'services/spraySubmissions/sagas';
import commoditiesSagas from 'services/commodities/sagas';
import {
    watchLogin,
    watchRenewIdToken,
    watchSignInAsUser
} from './services/auth/sagas';
import {
    watchContainerGroupLoadRequested,
    watchEventPrintLabelsRequested,
    watchEventCancelLabelsRequested
    // @ts-ignore
} from './services/containerGroups/sagas';
// @ts-ignore
import documentSetsSagas from './services/documentSets/sagas';
import entitiesSagas from './services/entities/sagas';
import equipmentSagas from './services/equipment/sagas';
import equipmentSetsSagas from './services/equipmentSets/sagas';
import {
    watchEventsLoadRequested,
    watchEventsPollingRequested,
    watchEventLoadRequested,
    watchEventCreateRequested,
    watchEventUpdateRequested
    // @ts-ignore
} from './services/events/sagas';
import {
    watchCreateGroup,
    watchEditGroup,
    watchDeleteGroup
    // @ts-ignore
} from './services/groups/sagas';
import harvestEventDocumentsSagas from './services/harvestEventDocuments/sagas';
import harvestEventsSagas from './services/harvestEvents/sagas';
import {
    watchLoadOrganizations,
    watchRequestedNewOrganization
    // @ts-ignore
} from './services/organizations/sagas';
import {
    watchCreatePerson,
    watchEditPerson,
    watchDeletePerson,
    watchRequestedExportGroupedPeople,
    watchRequestedImportGroupedPeople
    // @ts-ignore
} from './services/people/sagas';
// @ts-ignore
import routerSagas from './services/router/sagas';
import {
    watchQuantityForecastsCreateRequested,
    watchQuantityForecastsLoadRequested,
    watchQuantityForecastsUpdateRequested
    // @ts-ignore
} from './services/quantityForecasts/sagas';
import {
    watchReportsHarvestInspectionsLoadRequested,
    watchReportsHarvestInspectionsPollingRequested,
    watchReportsHarvestInspectionsExportRequested
    // @ts-ignore
} from './services/reportsHarvestInspections/sagas';
import {
    watchReportsHarvestInspectionsAllLoadRequested,
    watchReportsHarvestInspectionsAllPollingRequested,
    watchReportsHarvestInspectionsAllExportRequested
    // @ts-ignore
} from './services/reportsHarvestInspectionsAll/sagas';
import {
    watchReportsHarvestInspectionsAllMergedLoadRequested,
    watchReportsHarvestInspectionsAllMergedPollingRequested,
    watchReportsHarvestInspectionsAllMergedExportRequested
    // @ts-ignore
} from './services/reportsHarvestInspectionsAllMerged/sagas';
import {
    watchReportsHarvestInspectionsPeopleLoadRequested,
    watchReportsHarvestInspectionsPollingPeopleRequested
    // @ts-ignore
} from './services/reportsHarvestInspectionsPeople/sagas';
import {
    watchReportsHarvestTimesheetsAllLoadRequested,
    watchReportsHarvestTimesheetsAllPollingRequested,
    watchReportsHarvestTimesheetsAllExportRequested
    // @ts-ignore
} from './services/reportsHarvestTimesheetsAll/sagas';
// @ts-ignore
import sharedEventSagas from './services/sharedEvent/sagas';
import sprayEventsSagas from './services/sprayEvents/sagas';
import sprayEventsForSubmissionSagas from './services/sprayEventsForSubmission/sagas';
import timesheetSagas from './services/timesheet/sagas';
// @ts-ignore
import timesheetEntriesSagas from './services/timesheetEntries/sagas';
import timesheetsSagas from './services/timesheets/sagas';
// @ts-ignore
import timesheetTimesheetEntriesSagas from './services/timesheetTimesheetEntries/sagas';
import {
    watchLoadUsersMe
    // @ts-ignore
} from './services/usersMe/sagas';
import scaffoldDataSagas from './services/scaffoldData/sagas';
import {
    watchEnableSchema,
    watchDisableSchema
    // @ts-ignore
} from './services/schemas/sagas';
// @ts-ignore
import { watchVersionPollingRequested } from './services/version/sagas';
// @ts-ignore
import workTypeSagas from './services/workTypes/sagas';
import productsSagas from './services/products/sagas';
import { watchResetPassword } from './services/resetPassword/sagas';
import myTimesheetEntries from './services/myTimesheetEntries/sagas';
import worksheetSagas from './services/worksheet/sagas';
import virtualizedTableSagas from './services/virtualizedTable/sagas';
import sprayedEntitiesByDateSagas from './services/sprayedEntitiesByDate/sagas';
import activeIngredientSagas from './services/activeIngredients/sagas';
import timesheetHolidaySagas from './services/timesheetHolidays/sagas';
import payrollExportsSagas from './services/payrollExports/sagas';
import spraySubmissionSagas from './services/spraySubmission/sagas';
import fertilizerProductsSagas from './services/fertilizerProducts/sagas';
import fertilizerEventsSagas from './services/fertilizerEvents/sagas';
import appliedFertilizerEntitiesByDateSagas from './services/appliedFertilizerEntitiesByDate/sagas';
import documentsSagas from './services/documents/sagas';
import reEntryWarningSagas from './services/reEntryWarning/sagas';
import cropsurePasswordsSagas from './services/cropsurePasswords/sagas';
import varietiesSagas from './services/varieties/sagas';

function* rootSaga(): SagaIterator {
    const sagas = [
        watchLogin,
        watchRenewIdToken,
        watchSignInAsUser,
        watchContainerGroupLoadRequested,
        watchEventPrintLabelsRequested,
        watchEventCancelLabelsRequested,
        documentsSagas,
        documentSetsSagas,
        harvestEventDocumentsSagas,
        harvestEventsSagas,
        entitiesSagas,
        equipmentSagas,
        equipmentSetsSagas,
        watchEventsLoadRequested,
        watchEventsPollingRequested,
        watchEventLoadRequested,
        watchEventCreateRequested,
        watchEventUpdateRequested,
        watchCreateGroup,
        watchEditGroup,
        watchDeleteGroup,
        watchLoadOrganizations,
        watchRequestedNewOrganization,
        watchCreatePerson,
        watchEditPerson,
        watchDeletePerson,
        watchRequestedExportGroupedPeople,
        watchRequestedImportGroupedPeople,
        watchQuantityForecastsCreateRequested,
        watchQuantityForecastsLoadRequested,
        watchQuantityForecastsUpdateRequested,
        watchReportsHarvestInspectionsLoadRequested,
        watchReportsHarvestInspectionsPollingRequested,
        watchReportsHarvestInspectionsExportRequested,
        watchReportsHarvestInspectionsAllLoadRequested,
        watchReportsHarvestInspectionsAllPollingRequested,
        watchReportsHarvestInspectionsAllExportRequested,
        watchReportsHarvestInspectionsAllMergedLoadRequested,
        watchReportsHarvestInspectionsAllMergedPollingRequested,
        watchReportsHarvestInspectionsAllMergedExportRequested,
        watchReportsHarvestInspectionsPeopleLoadRequested,
        watchReportsHarvestInspectionsPollingPeopleRequested,
        watchReportsHarvestTimesheetsAllLoadRequested,
        watchReportsHarvestTimesheetsAllPollingRequested,
        watchReportsHarvestTimesheetsAllExportRequested,
        sharedEventSagas,
        sprayEventsSagas,
        sprayEventsForSubmissionSagas,
        timesheetSagas,
        timesheetEntriesSagas,
        timesheetsSagas,
        timesheetTimesheetEntriesSagas,
        routerSagas,
        watchLoadUsersMe,
        scaffoldDataSagas,
        watchEnableSchema,
        watchDisableSchema,
        watchVersionPollingRequested,
        worksheetSagas,
        workTypeSagas,
        watchResetPassword,
        myTimesheetEntries,
        virtualizedTableSagas,
        productsSagas,
        sprayedEntitiesByDateSagas,
        activeIngredientSagas,
        timesheetHolidaySagas,
        payrollExportsSagas,
        spraySubmissionsSagas,
        spraySubmissionSagas,
        fertilizerProductsSagas,
        fertilizerEventsSagas,
        appliedFertilizerEntitiesByDateSagas,
        reEntryWarningSagas,
        cropsurePasswordsSagas,
        varietiesSagas,
        commoditiesSagas
    ];

    yield all(
        sagas.map((saga) =>
            // eslint-disable-next-line func-names
            spawn(function* () {
                while (true) {
                    try {
                        yield call(saga);
                        break;
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.log(error);
                    }
                }
            })
        )
    );
}

export default rootSaga;
